import {
  GoalBasedExpensePeriod,
  GoalBasedFinancialPlanExpensePatchRequest,
  GoalBasedFinancialPlanExpensePostRequest,
} from "@fartherfinance/frontend/api/FinancialPlans/expenses/types";
import type {
  GoalBasedFinancialPlanExpenseId,
  GoalBasedFinancialPlanId,
} from "@fartherfinance/frontend/api/FinancialPlans/ids";

import { AddedAccountOption } from "../Assets/Types";
import {
  ApproachField,
  AutoTransportField,
  BillsUtilitiesField,
  BusinessField,
  CharitableGivingField,
  DiningOutField,
  EducationField,
  EntertainmentField,
  ExpensePeriodField,
  FeesChargesField,
  GiftField,
  GroceriesField,
  HealthFitnessField,
  KidsField,
  MiscField,
  NameField,
  OwnerField,
  PaymentAccountField,
  RentField,
  ShoppingField,
  TargetAmountField,
  TravelField,
  UncategorizedField,
} from "../Shared/constants";
import { OwnerFieldType } from "../Shared/Types";

type ExpensesFormFieldTypes = {
  [OwnerField]: OwnerFieldType;
  [NameField]: string;
  [TargetAmountField]: string;
  [ExpensePeriodField]: GoalBasedExpensePeriod;
  [ApproachField]: { label: string; value: string };
  [AutoTransportField]: string;
  [BillsUtilitiesField]: string | undefined;
  [BusinessField]: string | undefined;
  [CharitableGivingField]: string | undefined;
  [DiningOutField]: string | undefined;
  [EducationField]: string | undefined;
  [EntertainmentField]: string | undefined;
  [FeesChargesField]: string | undefined;
  [GiftField]: string | undefined;
  [GroceriesField]: string | undefined;
  [HealthFitnessField]: string | undefined;
  [KidsField]: string | undefined;
  [MiscField]: string | undefined;
  [RentField]: string | undefined;
  [ShoppingField]: string | undefined;
  [TravelField]: string | undefined;
  [UncategorizedField]: string | undefined;
  [PaymentAccountField]: AddedAccountOption | null | undefined;
};

export type PickExpensesFormFields<T extends keyof ExpensesFormFieldTypes> = {
  [K in T]: ExpensesFormFieldTypes[K];
};

export const approachOptions = [
  {
    label: "Simple",
    value: "SimpleLiving",
  },
  {
    label: "Detailed Worksheet",
    value: "DetailedLiving",
  },
];

export interface DeleteParams {
  goalBasedFinancialPlanId: GoalBasedFinancialPlanId;
  goalBasedFinancialPlanExpenseId: GoalBasedFinancialPlanExpenseId;
}
export interface PostParams {
  goalBasedFinancialPlanId: GoalBasedFinancialPlanId;
  body: GoalBasedFinancialPlanExpensePostRequest;
}

export interface PatchParams {
  goalBasedFinancialPlanId: GoalBasedFinancialPlanId;
  goalBasedFinancialPlanExpenseId: GoalBasedFinancialPlanExpenseId;
  body: GoalBasedFinancialPlanExpensePatchRequest;
}
